import { render, staticRenderFns } from "./NewPwdLessLoginRootComponent.vue?vue&type=template&id=8fc161c2"
import script from "./NewPwdLessLoginRootComponent.vue?vue&type=script&lang=js"
export * from "./NewPwdLessLoginRootComponent.vue?vue&type=script&lang=js"
import style0 from "./NewPwdLessLoginRootComponent.vue?vue&type=style&index=0&id=8fc161c2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports